class window.ClickableRow
  @init: ->
    $(".clickable-row > td:not(.no-click)").click ->
      window.document.location = $(this).parent().data("href")